// Vendor Service exports — endpoint definitions live in @trackly/shared (createVendorApi); this
// instantiates the single web-authenticated instance and re-exports its hooks so existing
// importers across Trackly.WebClient are unaffected by the shared-package extraction.
import { vendorApi } from './vendorApiBase';

export { vendorApi };
export const { useGetVendorByIdQuery, useGetActiveVendorsQuery, useUpsertVendorMutation } = vendorApi;
export { createDefaultVendor } from './vendor';
export type { VendorView, VendorWorklistView, VendorUpsertRequest } from '@trackly/shared';
